export const CamperThumbnailSVG = (props) => (
  <svg
    height={10}
    viewBox="0 0 21 10"
    width={21}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M.962 0h19.889v9.968s-3.917-3.34-9.934-3.364C5.067 6.581.962 9.927.962 9.927z"
      fill="#da291c"
    />
  </svg>
);
